import { Button, Divider, Form, Input, Modal, Tag, message, notification } from "antd";
import { antdConvertDataSave, convertDataUSParaBrasilEHora } from "../../utils/Conversores";
import { FaEdit, FaGlobe, FaInstagram, FaSearch, FaTrash } from "react-icons/fa";
import moment from "moment";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { EmitError } from "../../utils/EmitError";
import { ThemeContext } from "../../contexts/ThemeContext";
import useAuth from "../../hooks/useAuth";
import NoticiasService from "../../services/http/services/NoticiasService";
import dayjs from "dayjs";

export default function useNoticias() {

    const refController = useRef(new AbortController());
    const { userCan } = useAuth();
    const [isEditarNoticia, setIsEditarNoticia] = useState(false);
    const [noticias, setNoticias] = useState<any[]>([]);
    const [formNoticia] = Form.useForm();
    const [noticiaDescricao, setNoticiaDescricao] = useState<any>(null);
    const refFormNoticia = useRef<any>(null);
    const [fileList, setFileList] = useState<any>([]);
    const refFileList = useRef<any>([]);
    const [isModalNoticiaOpen, setIsModalNoticiaOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [imagemModal, setImagemModal] = useState<any>(null);
    const [isModalImagemOpen, setIsModalImagemOpen] = useState(false);

    const [visibleDatePicker, onVisibleDatePicker] = useState(false);
    const [defaultValueDatePicker, onDefaultValueDatePicker] = useState<Date>();

    const [noticiaEditar, setNoticiaEditar] =
        useState<any | null>(null);
    const [dataEntity, setdataEntity] = useState(
        JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null
    );

    const { theme } = useContext(ThemeContext);
    const refContagemDoFiltroNoticias = useRef<Array<any>>([]);

    useEffect(() => {
        return () => refController.current.abort();
    }, []);

    const handleChangeImagensNoticia = (info: any) => {
        let newFileList = [...info.fileList];

        newFileList = newFileList.map((file) => {
            const isJpgOrPng =
                file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "image/jpg";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (file.type) {
                if (!isJpgOrPng) {
                    message.error("Somente arquivos JPG/PNG são suportados.");
                    // remove o arquivo inválido da lista
                    return false;
                }

                if (!isLt2M) {
                    message.error("A imagem deve ser menor que 2MB.");
                    // return; // Ignora o arquivo inválido
                    return false;
                }
                return file;
            }
            return file;
        });

        //remove os arquivos inválidos da lista
        newFileList = newFileList.filter((file) => {
            if (file !== false) {
                return file;
            }
        });

        formNoticia.setFieldsValue({
            imagensNoticia: newFileList,
        });

        setFileList(newFileList);
        refFileList.current = newFileList
    };

    const handleEditorContentChange = (updatedHtml: any) => {
        formNoticia.setFieldsValue({
            descricaoNoticia: updatedHtml,
        });
    };

    const handleImagemCancel = () => {
        setIsModalImagemOpen(false);
    };

    const removerImagemNoticia = useCallback((file: any, index: number) => {

        let newArrayImgsCopy = [...refFileList.current]

        Modal.confirm({
            title: "Remover imagem",
            content:
                "Deseja realmente remover a imagem? (Essa ação não pode ser desfeita)",
            okText: "Sim",
            cancelText: "Não",
            onOk() {

                if (!file?.uid) {
                    let idNoticia = refFormNoticia.current.getFieldValue("idNoticia");

                    NoticiasService.deleteGestorNoticiasImage(
                        idNoticia,
                        file,
                        refController.current.signal
                    )
                        .then((result) => {
                            notification.success({
                                message: "Sucesso",
                                description: "Imagem excluida com sucesso!",
                            });
                            getNoticias();
                            newArrayImgsCopy.splice(index, 1);
                            setFileList(newArrayImgsCopy);
                            refFileList.current = newArrayImgsCopy

                        })
                        .catch((error) => {

                            notification.error({
                                message: "Erro",
                                description:
                                    error?.response?.data?.message ||
                                    "Não foi possivel excluir a imagem!",
                            });
                            return
                        });

                    // api
                    //     .delete(
                    //         urlContratoNoticias +
                    //         "/" +
                    //         idNoticia + "/image",
                    //         {
                    //             headers: {
                    //                 Authorization: "Bearer " + getToken(),
                    //             },
                    //             data: {
                    //                 image: file,
                    //             },
                    //         }
                    //     )

                } else {

                    // remover quando imagem ainda nao foi salva no servidor
                    newArrayImgsCopy.splice(index, 1);
                    setFileList(newArrayImgsCopy);
                    refFileList.current = newArrayImgsCopy
                }
            },
            onCancel() { },
        });
    }, [])

    const salvarNoticia = useCallback((values: any, escondeModal: boolean) => {
        setIsLoading(true);

        try {
            const data = new FormData();
            data.append("title", values.tituloNoticia);
            data.append("link", values.linkNoticia);
            data.append("description", values.descricaoNoticia);
            data.append("category", values.categoriaNoticia);

            if (values?.dataNoticia) {
                values.dataNoticia = dayjs(values.dataNoticia).toDate();
            }
            // values.dataNoticia = antdConvertDataSave(values.dataNoticia, true)
            data.append("date", values.dataNoticia);

            data.append(
                "emphasis",
                String(values.destaqueNoticia == 1 ? true : false)
            );
            data.append(
                "entityId", values.entityId
            );
            const imagens = formNoticia.getFieldValue("imagensNoticia");

            try {
                let dataImagens: any = [];
                //se imagens não for um array da um split
                if (!Array.isArray(imagens)) {
                    dataImagens = imagens.split(",");
                } else {
                    dataImagens = imagens;
                }
                if (imagens) {
                    for (let i = 0; i < dataImagens.length; i++) {
                        if (dataImagens[i]?.originFileObj) {
                            data.append(
                                "images",
                                dataImagens[i]?.originFileObj
                            );
                        } else {
                            data.append("images", dataImagens[i]);
                        }
                    }
                } else {
                    notification.error({
                        message: "Erro",
                        description: "Selecione uma imagem!",
                    });
                    setIsLoading(false);
                    return;
                }
            } catch (error) {
                setIsLoading(false);
            }
            if (values.idNoticia) {

                NoticiasService.putGestorNoticias(
                    values.idNoticia,
                    data,
                    refController.current.signal
                )
                    .then((result) => {
                        notification.success({
                            message: "Sucesso",
                            description: "Notícia atualizada com sucesso!",
                        });
                        if (escondeModal) {
                            setIsModalNoticiaOpen(false);
                        }
                        setNoticiaDescricao("");
                        setIsLoading(false);
                        getNoticias();
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        EmitError(error, true, "useEffect");
                    });

                // api
                //     .put(
                //         urlContratoNoticias + "/" + values.idNoticia,
                //         data,
                //         {
                //             headers: {
                //                 Authorization: "Bearer " + getToken(),
                //                 "Content-Type": "multipart/form-data",
                //             },
                //         }
                //     )

            } else {

                NoticiasService.postGestorNoticias(
                    data,
                    refController.current.signal
                )
                    .then((result) => {
                        notification.success({
                            message: "Sucesso",
                            description: "Notícia salva com sucesso!",
                        });
                        setIsModalNoticiaOpen(false);
                        setIsLoading(false);
                        getNoticias();
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        EmitError(error, true, "useEffect");
                    });

                // api
                //     .post(urlContratoNoticias, data, {
                //         headers: {
                //             Authorization: "Bearer " + getToken(),
                //             "Content-Type": "multipart/form-data",
                //         },
                //     })

            }
        } catch (error) {
            let msgErro: any = error as Error;
            notification.error({
                message: "Erro",
                description: msgErro?.response?.data?.message
                    ? msgErro?.response?.data?.message
                    : "Entre em contato com o suporte!",
            });
            setIsLoading(false);
            return false;
        }
    }, []);


    const onClickBotaoSalvarNoticia = useCallback((): void => {
        setIsLoading(true);

        //Espera 1 segundo
        setTimeout(() => {
            refFormNoticia.current
                .validateFields()
                .then((values: any) => {
                    values.entityId = dataEntity.entity.id;
                    salvarNoticia(values, true);
                })
                .catch((errorInfo: any) => {
                    notification.error({
                        message: "Erro",
                        description: "Preencha os campos obrigatórios!",
                    });

                    setIsLoading(false);
                });
        }, 500);

    }, [noticiaEditar]);

    const uploadImagensNoticia = () => {

        // Pega o idNoticia no formulário
        let idNoticia = refFormNoticia.current.getFieldValue("idNoticia");
        const formData = new FormData();

        // Adicione cada arquivo da fileList ao formData
        fileList.forEach((file: any) => {
            formData.append(`imagens`, file?.originFileObj);
        });

        NoticiasService.patchGestorNoticias(
            idNoticia,
            formData,
            refController.current.signal
        )
            .then((data) => {
                //Atualiza o valor do campo imagensNoticia no form
                refFormNoticia.current.setFieldsValue({
                    imagensNoticia: data.imagens,
                });

                message.success(`Todas as imagens foram enviadas com sucesso.`);
                getNoticias();
            })
            .catch((error) => {
                // Lide com erros aqui
                message.error(`Falha ao enviar imagens.`);
            });

        // api
        //     .patch(
        //         urlContratoEntidade + "/noticia/" + idNoticia,
        //         formData
        //     )

    };

    const showModalNoticia = () => {
        formNoticia.setFieldsValue({
            // contratoEntidadeId: entidade,
        });
        setIsModalNoticiaOpen(true);
    };

    const handleNoticiaCancel = () => {
        setFileList([]);
        refFileList.current = []
        setIsModalNoticiaOpen(false);
    };

    const getNoticias = useCallback(() => {
        const buscaDeDados = async () => {
            try {
                setIsLoading(true);
                const data = await NoticiasService.getGestorNoticias(
                    dataEntity.entity.id,
                    refController.current.signal
                );

                data.sort((a: any, b: any) => {
                    return (
                        moment(b.created_at).unix() -
                        moment(a.created_at).unix()
                    );
                });

                setNoticias(data);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                EmitError(error, true, "useEffect");
            }
        };
        return buscaDeDados();
    }, []);

    const excluirNoticia = useCallback((id: number) => {
        try {
            //Confirmação de exclusão
            Modal.confirm({
                title: "Excluir notícia",
                content:
                    "Deseja realmente excluir a notícia? (Essa ação não pode ser desfeita)",
                okText: "Sim",
                cancelText: "Não",
                onOk() {

                    NoticiasService.deleteGestorNoticias(
                        id,
                        refController.current.signal
                    )
                        .then((result: any) => {
                            notification.success({
                                message: "Sucesso",
                                description: "Notícia excluida com sucesso!",
                            });
                            getNoticias();
                        })
                        .catch((error: any) => {
                            notification.error({
                                message: "Erro",
                                description:
                                    "Não foi possivel excluir a notícia!",
                            });
                        });

                    // api.delete(urlContratoNoticias + '/' + id, {
                    //     headers: {
                    //         Authorization: "Bearer " + getToken(),
                    //     },
                    // })

                },
                onCancel() { },
            });
        } catch (error) {
            let msgErro: any = error as Error;
            notification.error({
                message: "Erro",
                description: msgErro?.response?.data?.message
                    ? msgErro?.response?.data?.message
                    : "Entre em contato com o suporte!",
            });
        }
    }, []);


    const getColumnSearchProps = useCallback(
        (dataIndex: any) => ({
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={(node) => { }}
                        placeholder={`Buscar ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) => {
                            setSelectedKeys(
                                e.target.value ? [e.target.value] : []
                            );
                        }}
                        onPressEnter={() => {
                            confirm();
                        }}
                        style={{
                            width: 188,
                            marginBottom: 8,
                            display: "block",
                        }}
                    />
                    <Button
                        type="primary"
                        onClick={() => {
                            confirm();
                        }}
                        icon={<FaSearch />}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={clearFilters}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Limpar
                    </Button>
                </div>
            ),
            filterIcon: (filtered: any) => (
                <FaSearch
                    style={{ color: filtered ? "#1890ff" : undefined }}
                />
            ),
            onFilter: (value: any, record: any) =>
                record[dataIndex]
                    ? record[dataIndex]
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    : "",
        }),
        []
    );

    const columnsNoticias = [
        {
            title: "Origem",
            dataIndex: "instagramId",
            width: "5%",
            sorter: (a: any, b: any) => a.instagramId - b.instagramId,
            showSorterTooltip: false,
            render: (val: any) => {
                const icone = val ? (
                    <FaInstagram
                        style={{
                            color: "#C13584",
                            fontSize: 20,
                        }}
                    />
                ) : (
                    <FaGlobe
                        style={{
                            color: "#1890ff",
                            fontSize: 20,
                        }}
                    />
                );

                return (
                    <span>
                        {icone}
                    </span>
                );
            }
        },
        {
            title: "Titulo",
            dataIndex: "title",
            width: "20%",
            sorter: (a: any, b: any) => a.title.localeCompare(b.title),
            ...getColumnSearchProps("title"),
            showSorterTooltip: false,
            render: (val: any) => {
                let titulo = val.length > 45 ? val.substring(0, 45) + "..." : val;
                return (
                    <span style={{ textTransform: "capitalize" }}>{titulo}</span>
                );
            }
        },
        {
            title: "Categoria",
            dataIndex: "category",
            width: "15%",
            sorter: (a: any, b: any) => {
                return a.category?.localeCompare(b.category);
            },
            showSorterTooltip: false,
            render: (val: any) => {
                return (
                    <span style={{ textTransform: "capitalize" }}>{val}</span>
                );
            },
        },
        {
            title: "Data",
            dataIndex: "date",
            width: "11%",
            render: (val: any) => {
                return moment(val).format("DD/MM/YYYY HH:mm")
            },
            showSorterTooltip: false,
        },
        {
            title: "Destaque",
            dataIndex: "emphasis",
            width: "5%",
            render: (val: any) => {
                return (
                    <span>
                        <Tag color={val ? "green" : "red"} key={val}>
                            {val ? "Sim" : "Não"}
                        </Tag>
                    </span>
                );
            },
        },
        {
            title: "Criado em",
            dataIndex: "created_at",
            key: "created_at",
            width: "11%",
            showSorterTooltip: false,
            sorter: (a: any, b: any) =>
                a.created_at.localeCompare(b.created_at),
            render: (criado: any) => moment(criado).format("DD/MM/YYYY HH:mm"),
        },
        {
            title: "Ações",
            dataIndex: "id",
            width: "10%",
            render: (id: any, record: any) => (
                <span>
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        size="small"
                        onClick={() => {
                            setIsEditarNoticia(true);
                            // Busca em noticias a noticia que vai ser editada
                            let noticiaFind = noticias.find((noticia) => {
                                return noticia.id === id;
                            });

                            let dtNoticia = null
                            if (noticiaFind?.date) {
                                onDefaultValueDatePicker(new Date(noticiaFind?.date))
                                dtNoticia = dayjs(noticiaFind?.date);
                            }

                            // Carrega os dados da noticia com block
                            formNoticia.setFieldsValue({
                                idNoticia: noticiaFind?.id,
                                tituloNoticia: noticiaFind?.title,
                                linkNoticia: noticiaFind?.link,
                                categoriaNoticia: noticiaFind?.category,
                                destaqueNoticia: noticiaFind?.emphasis
                                    ? "Sim"
                                    : "Não",
                                dataNoticia: dtNoticia,
                                descricaoNoticia: noticiaFind?.description,
                                imagensNoticia: noticiaFind?.images,
                                instagramId: noticiaFind?.instagramId,
                            });
                            setNoticiaDescricao(noticiaFind?.description);
                            // setFileList(noticia?.imagens?.split(","));
                            // Verifica se tem imagens

                            if (
                                typeof noticiaFind?.images === 'object' &&
                                noticiaFind?.images.length > 0
                            ) {
                                // Remove os valores null
                                const filteredArray = noticiaFind?.images?.filter((element: any) => element !== null);
                                setFileList(filteredArray);
                                refFileList.current = filteredArray
                            } else {
                                setFileList([]);
                                refFileList.current = []
                            }

                            setIsModalNoticiaOpen(true);
                        }}
                    >
                        <FaEdit />
                    </Button>
                    <Divider type="vertical" />
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        danger
                        size="small"
                        onClick={() => {
                            excluirNoticia(id);
                        }}
                    >
                        <FaTrash />
                    </Button>
                </span>
            ),
        },
    ];


    useEffect((): void => {
        // setIsSalvarOrEditar(true);

        const buscaDadosIniciais = async () => {
            try {

                refController.current = new AbortController();

                if (userCan('manage_news')) {
                    //Se tiver id
                    if (dataEntity.entity.id) {
                        getNoticias();
                    }
                }

            } catch (error) {
                setIsLoading(false);

            }
        };

        buscaDadosIniciais();
    }, []);

    return {
        dataEntity,
        userCan,
        setIsEditarNoticia,
        formNoticia,
        setFileList,
        refFileList,
        setNoticiaDescricao,
        showModalNoticia,
        columnsNoticias,
        noticias,
        isLoading,
        theme,
        refContagemDoFiltroNoticias,
        isModalImagemOpen,
        handleImagemCancel,
        imagemModal,
        isEditarNoticia,
        isModalNoticiaOpen,
        handleNoticiaCancel,
        refFormNoticia,
        handleChangeImagensNoticia,
        fileList,
        setImagemModal,
        setIsModalImagemOpen,
        uploadImagensNoticia,
        onClickBotaoSalvarNoticia,
        noticiaDescricao,
        handleEditorContentChange,
        removerImagemNoticia,
        visibleDatePicker,
        onVisibleDatePicker,
        defaultValueDatePicker,
    }
}
